<header class="dsDialog_header">
   <h2>{{ 'HOME.MORE_MENU' | transloco }}</h2>
</header>
<section class="dsDialog_content">
   <ul class="vjMainMenu">
      <ng-container *ngFor="let menu of menus">
         <li>
            <a (click)="menuClick(menu)" [id]="menu.name" [ngClass]="{ 'active': menu.active }" [title]="menu.name">
               <div class="vjMenuImage">
                  <img [src]="menu?.iconClassName">
               </div>
               <span>{{ menu?.name }}</span>
            </a>
         </li>
      </ng-container>
   </ul>
</section>
<footer class="dsDialog_actions vjMenuFooter"></footer>